import { SignIn } from "@clerk/react";
import sillLogo from "@sill/shared/assets/logo.svg";
import { IS_PREVIEW } from "../lib/pro-mode";

/**
 * Pro sign-in front door. Mirrors the consumer LoginPage but is invite-only —
 * there is NO `signUpUrl` (agents are admitted via the `proadmission` flow, not
 * open self-sign-up). Styled with the pro CSS-var tokens (the rest of the pro
 * surface uses inline styles + custom properties, not Tailwind utilities), and
 * rendered OUTSIDE the authenticated ProLayout shell (no sidebar).
 *
 * Under IS_PREVIEW (no Clerk key, dev / /preview/*) there is no ClerkProvider,
 * and Clerk's <SignIn> THROWS without one — the same provider dependency that
 * makes the gate no-op. So the page short-circuits to a static notice instead
 * of crashing the whole tree. `IS_PREVIEW` is a module-level constant, so this
 * branch is stable across renders.
 *
 * Accessibility: Clerk's own header logo is an <a> wrapping an <img> that stays
 * display:none until it loads, so the anchor has no accessible name before load
 * (and forever if the image fails). Clerk's markup can't be given an
 * aria-label, so the card opts out of the logo (`appearance.options.logoPlacement: "none"`) and
 * this page renders a named, non-interactive brand mark above it instead.
 */
export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-warm p-4">
      <div className="w-full max-w-[440px]">
        {IS_PREVIEW ? (
          <div className="text-center">
            <h1 className="view-h1 text-[22px]">
              Sill Pro
            </h1>
            <p className="view-sub mt-2.5">
              Sign-in is disabled in preview. Set a Clerk key to enable the
              agent login.
            </p>
          </div>
        ) : (
          <>
            <img
              src={sillLogo}
              alt="Sill"
              className="mx-auto mb-6 h-10 w-auto"
              data-testid="login-logo"
            />
            <SignIn
              path="/login"
              routing="path"
              fallbackRedirectUrl="/"
              appearance={{
                options: { logoPlacement: "none" },
                elements: {
                  rootBox: "mx-auto",
                  card: "shadow-lg",
                },
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
